<template>
    <div class="deployment-history-entry-set" v-if="hasHistoryEntries">
        <div class="date">{{ formatDateTime(deploymentHistorySet.lastAction.createDate) }}</div>
        <div class="edited-by">{{ deploymentHistorySet.lastAction.editedByFullname }} ({{ deploymentHistorySet.lastAction.editedBy }})</div>
        <HistoryEntry
            v-for="deploymentHistorySetEntry in deploymentHistorySet.entries"
            :key="'historyEntry|' + deploymentHistorySetEntry.deployment.id"
            :shifts="shifts"
            :rosterNames="rosterNames"
            :historySetEntry="deploymentHistorySetEntry"
            :organisationDeploymentStates="organisationDeploymentStates"
            :organisationDeploymentTypes="organisationDeploymentTypes"
            :projects="projects"
        />
        <CqButtonBar class="button-container">
            <CqButton v-if="canRestore" @click="$emit('restore:history')" label="Terug naar deze versie" class="restore-button" />
        </CqButtonBar>
    </div>
</template>

<script lang="ts">
    import {Shift, OrganisationDeploymentState, DeploymentType, Project} from '@cquential/api';
    import Dates from '@cquential/date-utils';
    import {DeploymentHistorySet} from '@/components/modals/types';
    import HistoryEntry from '@/components/modals/DeploymentHistoryModal/HistoryEntry.vue';
    import {CqButton, CqButtonBar} from '@cquential/ui';
    import {Component, Prop, Vue} from 'vue-facing-decorator';

    @Component({
        components: {
            HistoryEntry,
            CqButton,
            CqButtonBar,
        },
        emits: ['restore:history'],
    })
    export default class HistoryEntrySet extends Vue {
        @Prop({required: true}) public deploymentHistorySet!: DeploymentHistorySet;
        @Prop({required: true}) public organisationDeploymentStates!: Record<number, OrganisationDeploymentState>;
        @Prop({required: true}) public organisationDeploymentTypes!: Record<number, DeploymentType>;
        @Prop({required: true}) public shifts!: Record<number, Shift>;
        @Prop({required: true}) public rosterNames!: Record<number, string>;
        @Prop() public projects?: Project[];
        @Prop({type: Boolean}) public canRestore!: boolean;

        public get hasHistoryEntries(): boolean {
            for (const _ in this.deploymentHistorySet.entries) {
                return true;
            }

            return false;
        }

        public formatDateTime(date: Date): string {
            return Dates.Formatter.formatDateTime(date);
        }
    }
</script>

<style lang="scss" scoped>
    .deployment-history-entry-set {
        display: grid;
        grid-template-columns: subgrid;
        grid-column: 1 / -1;

        &:not(:first-child) {
            border-top: 0.125rem solid var(--calender-today-border);
        }
    }

    .date,
    .edited-by,
    .button-container {
        padding: .25rem .5rem;
    }

    .button-container {
        grid-row: 1;
        grid-column: 7;
    }
</style>
